export default __webpack_public_path__ + "static/media/btn_chatea_v.16637556.png";